import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { fieldShape } from 'app/shapes/bibPage';
import Field from './Field';

import './MetadataDisplay.scss';

export default function MetadataDisplay({ className, fields, compact, handleClick }) {
  const classNames = cn('cp-metadata-display', className, { 'metadata-display--compact': compact });

  return (
    <div className={classNames}>
      {fields.map(field => {
        return (
          <Field
            key={field.get('fieldName')}
            field={field}
            compact={compact}
            handleClick={fieldValue => handleClick(field, fieldValue)}
          />
        );
      })}
    </div>
  );
}

MetadataDisplay.propTypes = {
  className: PropTypes.string,
  compact: PropTypes.bool,
  fields: ImmutablePropTypes.listOf(fieldShape).isRequired,
  handleClick: PropTypes.func.isRequired
};
